import moment from 'moment';
import sources from '../assets/sources.json';
import { Reservation, Stay } from 'guest-data-types-ts-lib';
import { ValidationUtils } from './validation.utils';

export class ReservationUtils {
    public static isDateBeforeJuneFourth(date: Date): boolean {
        const juneFourth = moment('2018-06-04');
        return moment(date).isBefore(juneFourth);
    }

    public static isTripStarted(stay: Stay): boolean {
        return moment(stay.check_in_date_time).isBefore(moment(new Date()));
    }

    public static isSourceIdAllowed(reservation: Reservation): boolean {
        const sourceId = reservation.reservation_source_id || 0;
        return sources.some((item) => +item.sourceId === +sourceId);
    }

    public static formatConfirmationCode(confirmationCode: string): string {
        return confirmationCode.length === 8 ? `${confirmationCode.substr(0, 4)}-${confirmationCode.substr(4)}` : confirmationCode;
    }

    public static getRequiredByDate(stay: Stay): Date {
        const { check_in_date_time } = stay;
        const now = moment();
        const checkIn = moment(check_in_date_time);
        const diff = checkIn.diff(now, 'days');
        if (diff >= 30) {
            return checkIn.subtract(30, 'days').toDate();
        } else if (diff >= 7) {
            return checkIn.subtract(7, 'days').toDate();
        }
        return checkIn.toDate();
    }

    public static getBalanceDueDate(stay: Stay, reservation: Reservation): Date {
        const { total, balance, creation_date } = reservation;
        const { check_in_date_time } = stay;
        const checkInDate = moment(check_in_date_time);
        const creationDate = moment(creation_date || undefined);

        const wasBookedToBeInMoreThan30Days = checkInDate.diff(creationDate, 'days') >= 30;

        if (total > 0 && total === balance) {
            return creationDate.toDate();
        }

        if (wasBookedToBeInMoreThan30Days) {
            return checkInDate.subtract(30, 'days').toDate();
        }

        return creationDate.toDate();
    }

    public static isOutOrphanNightConditionWindow(stay: Stay, daysPriorFirstNight: number): boolean {
        const nowMoment = moment().startOf('day');
        const checkIn = moment(stay.check_in_date_time).startOf('day');
        return checkIn.diff(nowMoment, 'days') <= daysPriorFirstNight;
    }

    public static isPalManaged(reservation: Reservation | undefined): boolean {
        return Number(reservation?.id) >= 100_000_000;
    }

    //Some guest were having issues because of existing balance due for
    // 381	Wyndham Rewards Program and 178 Ski.com
    // This returns true for that or other configured channels
    public static shouldIgnoreBalance(reservation: Reservation): boolean {
        try {
            const channelsThatMustignoreBalance = (
                ValidationUtils.validateAndGetEnvVar('REACT_APP_IGNORE_PAYMENT_FOR_CHANNELS') + ''
            ).split(',');
            const sourceId = reservation?.reservation_source_id || -1;
            return channelsThatMustignoreBalance.some((x) => +x == +sourceId);
        } catch {
            return false;
        }
    }
}
